export default "__VITE_ASSET__B8T6t2CT__"